import { dataHooks } from '../../../libs/dataHooks';

export const headerTitleDataHooks = dataHooks<{
  title: {};
  search: {};
}>('headerTitle');
